import { Button, Checkbox, FormControlLabel, FormGroup, Paper, Skeleton, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { withStyles } from "@mui/styles";
import axios from "axios";
import * as React from "react";
import { Config } from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";
import { StrategicLayoutTool } from "./StrategicLayoutTool";

interface ToolsWrappedState {
    events: any[];
    selectedEvents: any[];
    eventsLoaded: boolean;
    simulatedLattency: number;
    loading: boolean;
}

interface ToolsWrappedProps {
    activeUser: any;
    activeEnv: any;
    classes: any;
}

class ToolsWrapped extends React.Component<ToolsWrappedProps, ToolsWrappedState> {

    constructor(props) {
        super(props);

        this.state = {
            events: [],
            eventsLoaded: false,
            selectedEvents: [],
            // Debug tools
            simulatedLattency: 0,
            loading: false,
        };

        document.title = Helpers.documentTitle("Tools");
    }

    componentDidMount() {
        this.fetchData();
    }

    async fetchData() {
        try {
            const response = await axios.get(`${Config.getInstance.apiUrl}/api/game_events`, {
                headers: { Authorization: Helpers.getSessionId() },
                timeout: 30000
            });

            this.setState({
                events: response.data,
                eventsLoaded: true,
            });
        } catch (e) {
            PopupMessage.error(e.response.data.message);
        }
    }
    async trigger(name: string) {
        try {
            if (!confirm("Are you sure, you want to do this? The action will be done for the STAGE environment")) {
                return;
            }

            await axios.post(`${Config.getInstance.apiUrl}/api/tools/trigger`, {
                name
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            });

            PopupMessage.success("Success");
        } catch (e) {
            PopupMessage.error(e);
        }
    }

    async endEvents() {
        try {
            if (this.state.selectedEvents.length === 0) {
                return PopupMessage.error("Select at least one event");
            }

            if (!confirm("Are you sure, you want to do this? The action will be done for the STAGE environment")) {
                return;
            }

            const loading = PopupMessage.loading("Ending events...");

            const response = await axios.post(`${Config.getInstance.apiUrl}/api/tools/trigger`, {
                name: "end_events",
                list: this.state.selectedEvents
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            });

            this.setState({
                selectedEvents: [],
            })

            loading(() => {
                PopupMessage.success("Success");
            });
        } catch (e) {
            PopupMessage.error(e.message);
        }
    }

    async clearEventData() {
        try {
            if (!confirm("Are you sure, you want to do this? The action will be done for the STAGE environment")) {
                return;
            }

            await axios.post(`${Config.getInstance.apiUrl}/api/tools/clear-event-data`, {
                name
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            });

            alert("Success");
        } catch (e) {
            alert(e);
        }
    }

    handleEventSelect = event => {
        let newArray = [...this.state.selectedEvents, event.target.name];

        if (this.state.selectedEvents.includes(event.target.name)) {
            newArray = newArray.filter(day => day !== event.target.name);
        }

        this.setState({
            selectedEvents: newArray
        });
    }

    updateSettings = () => {
        this.setState({ loading: true }, async () => {
            await axios.post(
                `${Config.getInstance.apiUrl}/api/debug_tools`,
                {
                    simulated_lattency: this.state.simulatedLattency,
                },
                {
                    headers: {
                        Authorization: Helpers.getSessionId(),
                    }
                },
            );

            this.setState({
                loading: false,
            });

            PopupMessage.success("Values updated!");
        });
    }

    renderEventsList() {
        if (!this.state.eventsLoaded) {
            return Array(15).fill(null).map(_ => <FormControlLabel
                control={<Skeleton width={25} height={25} variant="rectangular" style={{ margin: 9 }}/>}
                label={<Skeleton width={100} height={25} variant="text"/>}
                labelPlacement="end"
            />)
        }

        return this.state.events.map(event =>
            <FormControlLabel
                key={event.key}
                control={
                    <Checkbox
                        name={event.key}
                        checked={this.state.selectedEvents.includes(event.key)}
                    />
                }
                label={Helpers.getLocalizationName(event.name)}
                labelPlacement="end"
                onChange={this.handleEventSelect}
            />
        )
    }

    render() {
        const {classes} = this.props;

        return (
            <div className="contentPadding">
                <Paper className="root" elevation={0}>
                    <div style={{float: "left", padding: "15px 22px 15px 22px", width: "100%"}}>
                        <div className={classes.title}>
                            <Typography variant="h6" id="tableTitle">
                                Tools
                            </Typography>
                        </div>
                    </div>

                    <div style={{float: "left", width: "100%"}}>
                        <div style={{padding: 20}}>
                            <Typography variant="h6" style={{ marginBottom: 10 }}>
                                General
                            </Typography>

                            <Button disableElevation size="small" variant="contained" style={{marginRight: 15}}
                                    onClick={() => this.clearEventData()}>
                                Clear Event Data
                            </Button>

                            <Button disableElevation  size="small" variant="contained" style={{marginRight: 15}}
                                    onClick={() => this.trigger("ResetBounties")}>
                                Reset Bounties
                            </Button>

                            <Button disableElevation  size="small" variant="contained" style={{marginRight: 15}}
                                    onClick={() => this.trigger("EndSeason")}>
                                End Season
                            </Button>
                            <Button disableElevation  size="small" variant="contained" style={{marginRight: 15}}
                                    onClick={() => this.trigger("EndArenaSeason")}>
                                End Arena Season
                            </Button>
                        </div>
                    </div>

                    <div style={{float: "left", width: "100%"}}>
                        <div style={{padding: 20}}>
                            <Typography variant="h6" style={{ marginBottom: 10 }}>
                                Events
                            </Typography>

                            <FormGroup row>
                                {this.renderEventsList()}
                            </FormGroup>

                            <Button disableElevation
                                variant="contained"
                                style={{ marginRight: 15, marginTop: 10 }}
                                onClick={() => this.endEvents()}
                                size="small"
                            >
                                End selected events
                            </Button>
                        </div>
                    </div>
                </Paper>

                <Paper className="root" elevation={0}>
                    <div style={{padding: 20}}>
                        <Typography variant="h6" style={{ marginBottom: 10 }}>
                            Debug Tools
                        </Typography>
                    </div>

                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Value</TableCell>
                                <TableCell>Description</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>Simulated lattency</TableCell>
                                <TableCell>
                                    <TextField
                                        type="number"
                                        value={this.state.simulatedLattency}
                                        onChange={
                                            (e) => {
                                                this.setState({
                                                    simulatedLattency: parseInt(e.target.value, 10),
                                                });
                                            }
                                        }
                                        variant="outlined"
                                        size="small"
                                    />
                                </TableCell>
                                <TableCell>
                                    Defined in milliseconds.
                                    All DB write operations will be delayed by the specified value.
                                    This value is set to 0 after every DB writer deployment.
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>

                    <div style={{padding: 20}}>
                        <Button disableElevation variant="contained" size="small" onClick={this.updateSettings}>
                            Save changes
                        </Button>
                    </div>
                </Paper>
                <Paper className="root" elevation={0}>
                    <div style={{padding: 20}}>
                        <StrategicLayoutTool />
                    </div>
                </Paper>
            </div>
        );
    }
}

const styles: any = theme => ({
    actions: {
        color: theme.palette.text.secondary,
        float: "right",
    },
});

export const Tools = withStyles(styles)(ToolsWrapped);
